import WeighIn from "./WeighIn";

export default WeighIn;
